// Deprecated: centralized limits are enforced on the backend.
// These helpers are maintained for fallback display only and should not be used for enforcement.
export type PlanName = 'TRIAL' | 'STARTER' | 'PRO' | 'INTERNAL' | string;

const FALLBACK_LIMITS: Record<string, number> = {
  TRIAL: 0,
  STARTER: 1,
  PRO: 5,
  INTERNAL: Number.MAX_SAFE_INTEGER,
};

export function getIcpLimit(plan: PlanName): number {
  const key = (plan || '').toUpperCase();
  const limit = FALLBACK_LIMITS[key];
  return typeof limit === 'number' ? limit : 0;
}

export function isUnlimitedIcp(plan: PlanName): boolean {
  return getIcpLimit(plan) === Number.MAX_SAFE_INTEGER;
}


